import { PACKAGE_LIST_PARAMS_REQUEST } from 'models/package';

export const GET_PARENT_PACKAGE_OVERVIEW_LIST_REQUEST: string =
  'GET_PARENT_PACKAGE_OVERVIEW_LIST_REQUEST';

export const getParentPackageListAction = (
  params?: PACKAGE_LIST_PARAMS_REQUEST | null
) => {
  return {
    type: GET_PARENT_PACKAGE_OVERVIEW_LIST_REQUEST,
    payload: { params },
  };
};
